import React, { useState, Fragment } from 'react';
import { Seo } from '../../components';
import { useNavigate } from 'react-router-dom';
// import { HeaderThree } from './EnquiryForm';
const Onboarding = () => {
    const navigate = useNavigate();
    const [pageTitle] = useState("Digital Commerce and Marketing for Hyperlocal Businesses");

    return (
        <Fragment>
            <Seo title={`${pageTitle}`} />
            {/* <HeaderThree imgPath="../../images/full_logo.png" /> */}
            <section className="vh-100 d-flex flex-column justify-content-center align-items-center bg-dark-1" id="onBoarding">
                <img 
                    src="../../images/full_logo.png" 
                    alt="Logo" 
                    style={{ maxHeight: '100px', marginBottom: '30px', cursor:'pointer' }} 
                    onClick={()=>{navigate("/")}}
                />
                <div className="text-center">
                    <h1 className="color-orange-1 bannerTtl-2">
                        Onboard your E-Commerce website in 24 hrs Get 7 days free trial today
                    </h1>
                    <p className="color-white bannerSubTtl-1">
                        Turn your dream business into reality with Datumart design and
                        brand your online store effortlessly. Launch and grow faster
                        with personalized web and mobile storefronts that attract more
                        customers online and in-store.
                    </p>
                    <p className="color-white bannerSubTtl-1">
                        No payment information is required, you’ll be able to setup and take advantage of Datumart platform right away.
                    </p>
                    <div className="d-flex justify-content-center mt-4">
                        <button
                            className="btnDark customBtn mr-10"
                            type="button"
                            title="Get Started"
                            onClick={() => { navigate("/enquiry") }}
                        >
                            Enquiry
                        </button>
                        <button
                            className="btnDark customBtn ml-10"
                            type="button"
                            title="Get Started"
                            onClick={() => { navigate("/onboarding") }}
                        >
                            On-board
                        </button>
                    </div>
                </div>
            </section>
        </Fragment>
    );
};

export default Onboarding;